// extracted by mini-css-extract-plugin
export default {"wrap-contact":"Contact_wrap-contact__qdXdd","wrap-contact-info":"Contact_wrap-contact-info__AMpld","wrap-buttons":"Contact_wrap-buttons__jUZgG","button":"Contact_button__vMRIY"};